import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Alert from '@material-ui/lab/Alert';
import { Progress, InfoCard, MarkdownContent } from '@backstage/core-components';
import { GitlabCIApiRef } from '../../../api/GitlabCIApi.esm.js';
import '../../utils.esm.js';
import 'dayjs';
import { useApi } from '@backstage/core-plugin-api';
import { useAsync } from 'react-use';
import { gitlabProjectId, gitlabProjectSlug, gitlabInstance, gitlabReadmePath } from '../../gitlabAppData.esm.js';

const useStyles = makeStyles((theme) => ({
  infoCard: {
    marginBottom: theme.spacing(3),
    "& + .MuiAlert-root": {
      marginTop: theme.spacing(3)
    }
  }
}));
const ReadmeCard = (props) => {
  const classes = useStyles();
  const project_id = gitlabProjectId();
  const project_slug = gitlabProjectSlug();
  const gitlab_instance = gitlabInstance();
  const readme_path = gitlabReadmePath();
  const GitlabCIAPI = useApi(GitlabCIApiRef).build(
    gitlab_instance || "gitlab.com"
  );
  const { value, loading, error } = useAsync(async () => {
    const projectDetails = await GitlabCIAPI.getProjectDetails(
      project_slug || project_id
    );
    if (!projectDetails)
      throw new Error("wrong project_slug or project_id");
    let readmeData = void 0;
    try {
      readmeData = await GitlabCIAPI.getReadme(
        projectDetails.id,
        projectDetails.default_branch,
        readme_path
      );
    } catch (error2) {
      readmeData = void 0;
    }
    return {
      readme: readmeData
    };
  }, []);
  if (loading) {
    return /* @__PURE__ */ React.createElement(Progress, null);
  } else if (error) {
    return /* @__PURE__ */ React.createElement(Alert, { severity: "error", className: classes.infoCard }, error.message);
  }
  return /* @__PURE__ */ React.createElement(
    InfoCard,
    {
      title: "README",
      className: classes.infoCard,
      variant: props.variant
    },
    /* @__PURE__ */ React.createElement(
      MarkdownContent,
      {
        content: (value == null ? void 0 : value.readme) || "No README found",
        dialect: "gfm"
      }
    )
  );
};

export { ReadmeCard };
//# sourceMappingURL=ReadmeCard.esm.js.map
